import EditItem from "../../../Components/Items/Edit/EditItem";

const Editpage = ({user}) => {
  return (
    <>
      <EditItem user={user}/>
    </>
  );
};

export default Editpage;
